<template>
  <div>
    <data-table
      ref="table"
      :fetch-from="fetchForm"
      :fields="fields"
    >
      <template
        slot="actions"
        slot-scope="slotData"
      >
        <v-btn
          x-small
          color="primary"
          @click="showDetails(slotData.rowData)"
        >Edit</v-btn>
      </template>
    </data-table>
    <v-btn
      color="primary"
      small
      @click="showAddDialog()"
    >
      Add power agreement
    </v-btn>
    <modal-form
      title="Power agreement"
      :show="dialog"
      @update:show="dialog=$event"
      v-on:saveData="doSave"
    >
      <v-form
        v-model="valid"
        ref="form"
      >
        <v-row>
          <v-col cols="4">
            <agreement-type
              :readonly="isReadOnly()"
              label="Agreement type"
              :value="getValue(item, 'agreement_type')"
              @input="setValue(item, 'agreement_type', $event)"
            >
            </agreement-type>
          </v-col>
          <v-col cols="4">
            <agreement-status
              :readonly="isReadOnly()"
              label="Agreement status"
              :value="getValue(item, 'status')"
              @input="setValue(item, 'status', $event)"
            ></agreement-status>
          </v-col>
          <v-col cols="4">
            <connection-type
              :readonly="isReadOnly()"
              label="Connection type"
              :value="getValue(item, 'connection_type')"
              @input="setValue(item, 'connection_type', $event)"
            ></connection-type>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <power-provider
              :readonly="isReadOnly()"
              label="Power provider"
              :value="getValue(item, 'power_provider')"
              @input="setValue(item, 'power_provider', $event)"
            ></power-provider>
          </v-col>
          <v-col cols="4">
            <energy-source
              :readonly="isReadOnly()"
              label="Energy source"
              :value="getValue(item, 'energy_source')"
              @input="setValue(item, 'energy_source', $event)"
            ></energy-source>
          </v-col>
          <v-col cols="4">
            <text-field
              :readonly="isReadOnly()"
              label="Power Agreement Contract number"
              :value="getValue(item, 'power_agreement_contract_number')"
              @input="setValue(item, 'power_agreement_contract_number', $event)"
            ></text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <text-field
              :readonly="isReadOnly()"
              label="Customer code"
              :value="getValue(item, 'custumer_code')"
              @input="setValue(item, 'custumer_code', $event)"
            ></text-field>
          </v-col>
          <v-col cols="4">
            <text-field
              :readonly="isReadOnly()"
              label="OMM number"
              :value="getValue(item, 'omm_number')"
              @input="setValue(item, 'omm_number', $event)"
            ></text-field>
          </v-col>
          <v-col cols="4">
            <text-field
              :readonly="isReadOnly()"
              label="Nr. Of counter"
              :value="getValue(item, 'nr_of_counter')"
              @input="setValue(item, 'nr_of_counter', $event)"
            ></text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <currency-field
              :readonly="isReadOnly()"
              label="Amount (Agreement)"
              :value="getValue(item, 'amount_agreement')"
              @input="setValue(item, 'amount_agreement', $event)"
            ></currency-field>
          </v-col>
          <v-col cols="4">
            <method-of-payment
              :readonly="isReadOnly()"
              label="Method of payment"
              :value="getValue(item, 'method_of_payment')"
              @input="setValue(item, 'method_of_payment', $event)"
            ></method-of-payment>
          </v-col>
          <v-col cols="4">
            <payment-schedule
              :readonly="isReadOnly()"
              label="Payment schedule"
              :value="getValue(item, 'payment_schedule')"
              @input="setValue(item, 'payment_schedule', $event)"
            ></payment-schedule>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <currency-field
              :readonly="isReadOnly()"
              label="Cost (Monthly, Quarterly, Yearly, Other)"
              :value="getValue(item, 'cost')"
              @input="setValue(item, 'cost', $event)"
            ></currency-field>
          </v-col>
          <v-col cols="4">
            <date-picker
              :readonly="isReadOnly()"
              label="Start date"
              :value="getValue(item, 'start_date')"
              @input="setValue(item, 'start_date', $event)"
            ></date-picker>
          </v-col>
          <v-col cols="4">
            <date-picker
              :readonly="isReadOnly()"
              label="Termination date"
              :value="getValue(item, 'termination_date')"
              @input="setValue(item, 'termination_date', $event)"
            ></date-picker>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <text-field
              :readonly="isReadOnly()"
              label="Main fuse"
              :value="getValue(item, 'main_fuse')"
              @input="setValue(item, 'main_fuse', $event)"
            ></text-field>
          </v-col>
          <v-col cols="4">
            <limiter-type
              :readonly="isReadOnly()"
              label="Limiter type"
              :value="getValue(item, 'limiter_type')"
              @input="setValue(item, 'limiter_type', $event)"
            ></limiter-type>
          </v-col>
          <v-col cols="4">
            <text-field
              :readonly="isReadOnly()"
              label="Leased power"
              :value="getValue(item, 'leased_power')"
              @input="setValue(item, 'leased_power', $event)"
            ></text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <switch-button
              :readonly="isReadOnly()"
              label="FID with automatic connection"
              :value="getValue(item, 'fid_with_automatic_connection')"
              @change="setValue(item, 'fid_with_automatic_connection', $event)"
            ></switch-button>
          </v-col>
          <v-col cols="4">
            <text-field
              :readonly="isReadOnly()"
              label="Nr. Of substation"
              :value="getValue(item, 'nr_of_substation')"
              @input="setValue(item, 'nr_of_substation', $event)"
            ></text-field>
          </v-col>
          <v-col cols="4">
            <tenant-select
              :site="site"
              :readonly="isReadOnly()"
              label="Tenant"
              :value="getValue(item, 'tenant')"
              @input="setValue(item, 'tenant', $event)"
            >
            </tenant-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <distribution-area
              :readonly="isReadOnly()"
              label="Distribution area"
              :value="getValue(item, 'distribution_area')"
              @input="setValue(item, 'distribution_area', $event)"
            ></distribution-area>
          </v-col>
          <v-col cols="4">
            <distribution-section
              :readonly="isReadOnly()"
              label="Distribution section (pogon)"
              :value="getValue(item, 'distribution_section')"
              @input="setValue(item, 'distribution_section', $event)"
            ></distribution-section>
          </v-col>
          <v-col cols="4">
            <address-type
              :readonly="isReadOnly()"
              label="Address type"
              :value="getValue(item, 'address_type')"
              @input="setValue(item, 'address_type', $event)"
            ></address-type>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <display-field label="Town">{{ item.town }}</display-field>
          </v-col>
          <v-col cols="4">
            <s-textarea
              :readonly="isReadOnly()"
              label="Address / Real estate number"
              :value="getValue(item, 'address_real_estate_number')"
              @input="setValue(item, 'address_real_estate_number', $event)"
            ></s-textarea>
          </v-col>
          <v-col cols="4">
            Multi add items!
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <switch-button
              :readonly="isReadOnly()"
              label="Privilaged custumer"
              :value="getValue(item, 'privilaged_custumer')"
              @change="setValue(item, 'privilaged_custumer', $event)"
            ></switch-button>
          </v-col>
          <v-col cols="4">
            <switch-button
              :readonly="isReadOnly()"
              label="EoY - calculation of consumption"
              :value="getValue(item, 'eoy_calculation_of_consumption')"
              @change="setValue(item, 'eoy_calculation_of_consumption', $event)"
            ></switch-button>
          </v-col>
          <v-col cols="4">
            <s-textarea
              :readonly="isReadOnly()"
              label="Description of connection point, counter point and route"
              :value="getValue(item, 'description_connection_point')"
              @input="setValue(item, 'description_connection_point', $event)"
            ></s-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <s-textarea
              :readonly="isReadOnly()"
              label="Comments"
              :value="getValue(item, 'comments')"
              @input="setValue(item, 'comments', $event)"
            ></s-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <file-upload
              :readonly="isReadOnly()"
              label="Document"
              module="power_agreements"
              section="documents"
              :site_id="site.site_id"
              :item_id="itemId"
              @input="setValue(item, 'files', $event)"
            ></file-upload>
          </v-col>
        </v-row>
      </v-form>
    </modal-form>
  </div>
</template>

<script>
  import DataTable from '@/components/DataTable'
  import SitePowerAgreementService from '@/services/site-power-agreement'
  import ModalForm from '@/components/ModalForm'
  import ReactivityMixin from '@/mixins/Reactivity'
  import ValidationMixin from '@/mixins/Validation'
  import PermissionsMixin from '@/mixins/Permissions'
  import AgreementType from '@/components/codelist/AgreementType'
  import AgreementStatus from '@/components/codelist/AgreementStatus'
  import ConnectionType from '@/components/codelist/ConnectionType'
  import EnergySource from '@/components/codelist/EnergySource'
  import PowerProvider from '@/components/codelist/PoweProvider'
  import TextField from '@/components/TextField'
  import CurrencyField from '@/components/CurrencyField'
  import MethodOfPayment from '@/components/codelist/MethodOfPayment'
  import PaymentSchedule from '@/components/codelist/PaymentSchedule'
  import DatePicker from '@/components/DatePicker'
  import SwitchButton from '@/components/SwitchButton'
  import DistributionArea from '@/components/codelist/DistributionArea'
  import AddressType from '@/components/codelist/AddressType'
  import STextarea from '@/components/Textarea'
  import FileUpload from '@/components/FileUpload'
  import DisplayField from '@/components/DisplayField'
  import TenantSelect from '@/components/codelist/TenantSelect'
  import LimiterType from '../../../../components/codelist/LimiterType'
  import DistributionSection from '../../../../components/codelist/DistributionSection'

  export default {
    name: 'PowerAgreements',
    components: { DistributionSection, LimiterType, TenantSelect, DisplayField, FileUpload, STextarea, AddressType, DistributionArea, SwitchButton, DatePicker, PaymentSchedule, MethodOfPayment, CurrencyField, TextField, PowerProvider, EnergySource, ConnectionType, AgreementStatus, AgreementType, ModalForm, DataTable },
    mixins: [
      ReactivityMixin,
      ValidationMixin,
      PermissionsMixin,
    ],
    props: {
      site: {
        default: undefined,
      },
    },
    data: () => ({
      tab: undefined,
      valid: false,
      dialog: false,
      selected_index: -1,
      item: {},
      fields: [
        {
          name: 'status_name',
          title: 'Status',
        },
        {
          name: 'power_provider_name',
          title: 'Power provider',
        },
        {
          name: 'start_date',
          title: 'Start date',
        },
        {
          name: 'termination_date',
          title: 'Termination date',
        },
        {
          name: 'agreement_type_name',
          title: 'Agreement type',
        },
        {
          name: 'connection_type_name',
          title: 'Connection type',
        },
        {
          name: 'leased_power',
          title: 'Leased power',
        },
        {
          name: 'omm_number',
          title: 'OMM number',
        },
        {
          name: '__slot:actions',
          title: 'Actions',
        },
      ],
      section: 'contract',
    }),
    computed: {
      isEditing () {
        return this.item.id !== undefined
      },
      itemId () {
        if (this.item.id) {
          return this.item.id
        }
        return undefined
      },
    },
    methods: {
      fetchForm (urls, options) {
        const acs = new SitePowerAgreementService(this.site.id)
        return acs.list(options.params)
      },
      showAddDialog () {
        this.item = {}
        this.dialog = true
      },
      showDetails (item) {
        this.item = JSON.parse(JSON.stringify(item))
        this.dialog = true
      },
      doSave () {
        this.validate()
        if (this.valid) {
          if (this.isEditing) {
            const pas = new SitePowerAgreementService(this.site.id)
            pas.put(this.item.id, this.item).then((response) => {
              this.$refs.table.refresh()
              this.dialog = false
            })
          } else {
            const pas = new SitePowerAgreementService(this.site.id)
            pas.post(this.item).then((response) => {
              this.$refs.table.refresh()
              this.dialog = false
            })
          }
        }
      },
    },
  }
</script>

<style scoped>

</style>
